// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7222":"2b09056f","9297":"2b09056f","9465":"41c226da"}[chunkId] + ".chunk.css";
};